module.exports = __webpack_public_path__ + "img/105-594a49.png";